import React, { useEffect, useContext, useState } from 'react';
import clsx from 'clsx';

import QRCode from 'qrcode.react';

import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Button
} from '@material-ui/core';

import { PageContext } from '../../PageContext';

import { useTranslation } from "react-i18next";

import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles((theme) => ({
    root: {}
}));

export const LiveViewDialog = ({
    open,
    onClose,
    ...props
}) => {
    const classes = useStyles();

    const { t } = useTranslation();

    const {
        state
    } = useContext(PageContext);

    const {
        qrLiveViewer
    } = state;

    return (
        <Dialog
            className={clsx(classes.root, props.className)}
            open={open}
            onClose={onClose}>
            <DialogTitle>
                MyLiveViewer
            </DialogTitle>
            <DialogContent style={{ textAlign: "center" }}>
                {qrLiveViewer ?
                    <>
                        <QRCode
                            size={250}
                            value={JSON.stringify(qrLiveViewer)}
                        />
                        <br />
                        <br />
                        <DialogContentText>
                            {t("LabelUserLivewViewer")}
                        </DialogContentText>
                   {/*
                        <div>
                            <a
                                href="https://play.google.com/store/apps/details?id=com.teamonair.myFastAppLiveViewer&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1"
                                target="_blank">
                                <img
                                    style={{ width: "240px" }}
                                    alt="Google Play Badge"
                                    src={t("UrlGooglePlayBadge")}
                                />
                            </a>
                        </div>
                        <div>
                            <a
                                href="https://apps.apple.com/it/app/myliveviewer/id1539795908?itsct=apps_box_badge&amp;itscg=30200"
                                target="_blank"
                                style={{ display: "inline-block", overflow: "hidden", borderRadius: "13px", width: "200px", height: "83px" }}>
                                <img
                                    src={t("UrlAppStoreBadge")}
                                    alt="Download on the App Store"
                                    style={{ borderRadius: "13px", width: "200px", height: "83px" }}
                                />
                            </a>
                        </div>
                        */}
                    </>
                    :
                    <DialogContentText>
                        {t("LabelLivewViewerQrError")}
                    </DialogContentText>
                }
            </DialogContent>
            <DialogActions>
                <Button
                    autoFocus
                    onClick={onClose}
                    color="primary">
                    {t("ButtonClose")}
                </Button>
            </DialogActions>
        </Dialog>
    );
}